import $ from "jquery";

export default function ratingsForm() {
    $(".alert-login a").each(function () {
        const param = "return_url=" + location.href.split("#")[0] + "#ratings-form";
        if (this.search.length > 1) {
            this.search += "&" + param;
        } else {
            this.search = "?" + param;
        }
    });

    (function waitForRecaptcha() {
        //if (! "grecaptcha" in window) {
        //    return setInterval(waitForRecaptcha, 100);
        //}

        grecaptcha.ready(function ratingsForm() {
            $(".ratings-form").each(function () {
                const $ratingsForm = $(this),
                    captcha = grecaptcha.render($ratingsForm.find(".ratings-form-captcha").get(0), {
                        sitekey: "6LdCsagUAAAAAEVDKq3DVDQjkYHkCaRwu8LZiBYh",
                        size: "invisible",
                        badge: "inline",
                        callback() {
                            const values = {},
                                valuesArray = $ratingsForm.serializeArray();

                            for (let i = 0; i < valuesArray.length; i++) {
                                values[valuesArray[i].name] = valuesArray[i].value;
                            }

                            $.ajax(KK_PXA_PM_CREATE, {
                                method: "POST",
                                data: values,
                            }).done(function (res) {
                                $(".tx-kkpxapm-rating").html(res.rating);
                                $(".tx-kkpxapm-ratings").html(res.ratings);

                                ratingsForm();
                            });
                        },
                        "expired-callback": () => {
                            grecaptcha.reset(captcha);
                        },
                        "error-callback": () => {
                            $ratingsForm.find("input[type=submit]").attr("disabled", true);
                        },
                    });

                $ratingsForm.on("submit", e => {
                    e.preventDefault();
                    e.stopPropagation();

                    $ratingsForm.find("input[type=submit]").attr("disabled", true);

                    grecaptcha.execute(captcha);
                });

                $ratingsForm.find(".rating").on("click", function (e) {
                    const stars = Math.ceil((e.pageX - $(this).offset().left) / $(this).innerWidth() * 5);
                    $ratingsForm.find("#rating").val(stars).trigger("change");
                });
                $ratingsForm.find("#rating").on("change", function () {
                    const stars = $(this).val() * 20;
                    $ratingsForm.find(".rating").attr("title", `${Math.round(stars)}%`)
                        .find("span").css("width", `${stars}%`);
                });
            });
        });
    })();
}
